import { jsx, jsxs } from 'react/jsx-runtime';
import { useEffect, isValidElement } from 'react';
import { createPortal } from 'react-dom';
import { twMerge } from '@belong/common/twMerge';
import { IconClose } from '@belong/icons/dist/IconClose';
import clsx from 'clsx';
import { ButtonBase } from '../ButtonBase/ButtonBase.js';
import { Text } from '../Text/Text.js';
import css from './Toast.module.css.js';

function Toast({
  className,
  children,
  icon,
  isVisible,
  autocloseDuration,
  onClose,
  variant = 'default'
}) {
  useEffect(() => {
    if (isVisible && autocloseDuration) {
      setTimeout(() => {
        onClose();
      }, autocloseDuration);
    }
  }, [isVisible, autocloseDuration]);
  if (!isVisible) {
    return null;
  }
  return /*#__PURE__*/createPortal(jsx("div", {
    className: twMerge('fixed top-sm w-full z-toast md:top-xl md:m-auto md:left-0 md:right-0', css.wrapper, className),
    children: jsx("div", {
      className: "mx-sm md:mx-0",
      children: jsx("div", {
        className: clsx('box-border w-full rounded shadow', {
          'bg-dark-green': variant === 'default',
          'bg-red': variant === 'danger'
        }),
        children: jsxs("div", {
          className: "flex justify-between",
          children: [jsxs("div", {
            className: "flex w-10/12 items-center p-sm md:w-11/12",
            children: [/*#__PURE__*/isValidElement(icon) && jsx("div", {
              className: clsx('mr-sm hidden shrink-0 md:block', css.mainIcon),
              children: icon
            }), jsx(Text, {
              as: "span",
              className: "text-white",
              fontWeight: "semibold",
              children: children
            })]
          }), jsx("div", {
            className: "flex w-2/12 items-center md:w-1/12",
            children: jsx(ButtonBase, {
              className: "p-0 md:p-sm",
              onClick: onClose,
              children: jsx(IconClose, {
                className: clsx('w-lg text-white', css.closeIcon),
                height: 16,
                width: 16
              })
            })
          })]
        })
      })
    })
  }), document.getElementById('toast'));
}

export { Toast };
